export const col_1 = {
  "Corporate Board": [
    { staff_name: "Shea Vance", title: "Editor in Chief" },
    { staff_name: "Heather Chen", title: "Managing Editor" },
    { staff_name: "Albert Tsai", title: "Publisher" }
  ],
  "Copy": [
    { staff_name: "Posey Chiddix", title: "Head Copy Editor" },
    { staff_name: "Diego Carvajal Núñez", title: "Deputy Copy Editor" },
    { staff_name: "Daniel Knorek", title: "Deputy Copy Editor" },
    { staff_name: "Megha Parikh", title: "Deputy Copy Editor" },
    { staff_name: "Reese Ransweiler", title: "Deputy Copy Editor" },
    { staff_name: "Vaishu Sirkay", title: "Deputy Copy Editor" },
    { staff_name: "Emily Spencer", title: "Deputy Copy Editor" },
    { staff_name: "Eli Trokenheim", title: "Deputy Copy Editor" },
    
    { staff_name: "Eric Aguilar", title: "Senior Associate Copy Editor" },
    { staff_name: "Ella Ahner", title: "Senior Associate Copy Editor" },
    { staff_name: "Nola Gallo", title: "Senior Associate Copy Editor" },
    { staff_name: "Sally Kaye", title: "Senior Associate Copy Editor" },
    { staff_name: "Elizabeth Kushelevsky", title: "Senior Associate Copy Editor" },
    { staff_name: "Lily Lee", title: "Senior Associate Copy Editor" },
    { staff_name: "Sophia Lee", title: "Senior Associate Copy Editor" },
    { staff_name: "Natalie Wise", title: "Senior Associate Copy Editor" },
    { staff_name: "Georgia Bryan", title: "Senior Associate Copy Editor" },
    { staff_name: "Katharine Lee", title: "Senior Associate Copy Editor" },
    
    { staff_name: "Dalina Cao", title: "Associate Copy Editor" },
    { staff_name: "Gigi Chen", title: "Associate Copy Editor" },
    { staff_name: "Maxwell Gaynor", title: "Associate Copy Editor" },
    { staff_name: "Sreya Gupta", title: "Associate Copy Editor" },
    { staff_name: "Yoona Lee", title: "Associate Copy Editor" },
    { staff_name: "Grace Mazer", title: "Associate Copy Editor" },
    { staff_name: "Kathleen Yang", title: "Associate Copy Editor" },
    { staff_name: "Ames Yu", title: "Associate Copy Editor" },
    { staff_name: "Finn Brown", title: "Associate Copy Editor" },
    { staff_name: "Sebastian Cunto-Araujo", title: "Associate Copy Editor" },
    { staff_name: "June Liu", title: "Associate Copy Editor" },
    { staff_name: "Skerry Lu", title: "Associate Copy Editor" },
    { staff_name: "Serena Miles", title: "Associate Copy Editor" },
    { staff_name: "Claire Murray", title: "Associate Copy Editor" },
    { staff_name: "Jordan Straub", title: "Associate Copy Editor" },
    { staff_name: "Kelly Sung", title: "Associate Copy Editor" },
    { staff_name: "Lynn Tang", title: "Associate Copy Editor" },
  ],
  "City News": [
    { staff_name: "Thomas Stewart", title: "Deputy News Editor" },
    { staff_name: "Surina Venkat", title: "Deputy News Editor" },
    { staff_name: "Lara Harmankaya", title: "Staff Writer" },
  ],
};
export const col_2 = {
  "Engineering": [
    { staff_name: "Noel Negron", title: "Head of Engineering" },
    { staff_name: "Aishani Srikumar", title: "Engineering Manager" },
    { staff_name: "Violet Laing", title: "Engineering Manager" },
    { staff_name: "Julien Remy", title: "Engineering Manager" },
    { staff_name: "Dhruv Goya", title: "Associate Engineering Developer" },
    { staff_name: "Amber Li", title: "Associate Engineering Developer" },
    { staff_name: "Hannah Qi", title: "Associate Engineering Developer" },
  ],

  "Sports": [
    { staff_name: "Arielle Rieder", title: "Sports Editor" },
    { staff_name: "Jillian Prunty", title: "Sports Editor" },
    { staff_name: "Lucas Metzger", title: "Deputy Sports Editor" },
    { staff_name: "Ashley Flores", title: "Deputy Sports Editor" },
    { staff_name: "Nicholas Fink", title: "Deputy Sports Editor" },
    { staff_name: "Kaya Quebada", title: "Deputy Sports Editor" },
    { staff_name: "Andrew Vincenti", title: "Deputy Sports Editor" },
    { staff_name: "Emma Dignan", title: "Senior Staff Writer" },
    { staff_name: "Aidan Hassan", title: "Senior Staff Writer" },
    { staff_name: "Diane Lang", title: "Staff Writer" },
    { staff_name: "Holden Lombardo", title: "Staff Writer" },
  ],
  "Illustrations": [
    { staff_name: "Conner Sund", title: "Illustrations Editor" },
    { staff_name: "Shanying Liu", title: "Deputy Illustrations Editor" },
    { staff_name: "Saumya Chaudhry", title: "Deputy Illustrations Editor" },
    { staff_name: "Anaïs Fotsing", title: "Deputy Illustrations Editor" },
    { staff_name: "Ramona Delyser", title: "Deputy Illustrations Editor" },
    { staff_name: "Eva Vu-Stern", title: "Staff Illustrator" },
  ],
  "Spectrum": [
    { staff_name: "Manuela Moreyra", title: "Spectrum Editor" },
    { staff_name: "Loyca Jean", title: "Spectrum Deputy Editor" },
    { staff_name: "Isabella O'Connor", title: "Staff Writer" },
    { staff_name: "Ally Sepe", title: "Spectrum Deputy Editor" },
    { staff_name: "Terrah Garner", title: "Staff Writer" },
    { staff_name: "Suhani Arora", title: "Staff Writer" }
  ],
  "Arts and Culture": [
    { staff_name: "Joyce Zhang", title: "Arts & Culture Editor" },
    { staff_name: "Beatrice Moyers", title: "Deputy Arts & Culture Editor" },
    { staff_name: "Rachel Shaw", title: "Deputy Arts & Culture Editor" },
    { staff_name: "Ana Carpenter", title: "Deputy Arts & Culture Editor" },
    { staff_name: "Taylor Graham", title: "Deputy Arts & Culture Editor" },
    { staff_name: "Ian Romero", title: "Deputy Arts & Culture Editor" },
  ],
};
export const col_3 = {
  "Product": [
    { staff_name: "Daniela Velazquez", title: "Head of Product" },
    { staff_name: "Melinda Yao", title: "Product Manager" },
    { staff_name: "Stephen Lin", title: "Product Designer" },
    { staff_name: "Pallavi Saxena", title: "Product Designer" },
    { staff_name: "Anuka Manghwani", title: "Product Designer" },
  ],
  "Video": [
    { staff_name: "Elliot Heath", title: "Video Editor" },
    { staff_name: "Anna Strbka", title: "Deputy Video Editor" },
    { staff_name: "Liz Backus", title: "Deputy Video Editor" },
    { staff_name: "Emily Huang", title: "Deputy Video Editor" },
    { staff_name: "Teniola Adedire", title: "Video Associate" },
    { staff_name: "Julia Kotch", title: "Video Associate" },
    { staff_name: "Katie Chou", title: "Video Associate" },
  ],
  "Crosswords": [
    { staff_name: "Ananya Govindarajan", title: "Head of Crosswords" },
    { staff_name: "Anna Steel", title: "Crosswords Deputy Editor" },
    { staff_name: "Rich Vigliotti", title: "Crosswords Deputy Editor" },
  ],
"University News": [
  { staff_name: "Isha Banerjee", title: "University News Editor" },
  { staff_name: "Emily Pickering", title: "Deputy News Editor" },
  { staff_name: "Spencer Davis", title: "Deputy News Editor" },
  { staff_name: "Joseph Zuloaga", title: "Deputy News Editor" },
  { staff_name: "Molly Bordoff", title: "Deputy News Editor" },
  { staff_name: "Tulasi Cherukuri", title: "Deputy News Editor" },
  { staff_name: "Daksha Pillai", title: "Deputy News Editor" },
  { staff_name: "Celine Chien", title: "Staff Writer" },
  { staff_name: "Theresa Cullen", title: "Staff Writer" },
],
"Graphics": [
  { staff_name: "Jenny Ye", title: "Graphics Editor" },
  { staff_name: "Nathan Shurts", title: "Deputer Graphics Editor" },
  { staff_name: "Ava Fung", title: "Graphics Reporter" },
  { staff_name: "Bryan Ammons", title: "Graphics Reporter" },
  { staff_name: "Sofía Polar", title: "Graphics Reporter" },
],
};